import React, { Component } from 'react';
import { Form, Button, Modal } from 'semantic-ui-react';
import { observer } from 'mobx-react';

class OtherCostForm extends Component {
  state = {}
  // constructor(props) {
  //   super(props);
  //   this.handleChange = handleChange.bind(this);
  // }
  // componentDidMount() {
  //   if (this.props.item) this.itemToState(this.props.item);
  // }
  get isValid() {
    return this.props.model.description.length > 0;
  }
  // itemToState = item => {
  //   this.setState({
  //     description: item.description,
  //     qty: item.qty,
  //     costEach: item.costEach,
  //   })
  // }
  // handleSave = event => {
  //   event.preventDefault();
  //   this.setState({ isSaving: true });
  //   this.props.onSave({
  //     id: this.props.item ? this.props.item.id : null,
  //     description: this.state.description,
  //     qty: this.state.qty,
  //     costEach: this.state.costEach,
  //   }).then(result => {
  //     this.setState({ isSaving: false })
  //     this.props.onClose()
  //   });
  // }
  render() { 
    const { isSaving } = this.state;
    const { description, cost } = this.props.model;
    return (
      <Modal open={true}>
        <Modal.Header>Additional Cost</Modal.Header>
        <Modal.Content>
          <Form>
            <Form.Group>
              <Form.Input 
                width={8} 
                label='Description' 
                placeholder='Description' 
                name='description' 
                value={description} 
                onChange={this.handleChangeDescription} 
                autoFocus
              />
              <Form.Input 
                width={4} 
                label='Cost'  
                type='number' 
                step='0.01' 
                value={cost} onChange={this.handleChangeCost} />
            </Form.Group>
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button positive onClick={this.props.onSave} disabled={!this.isValid} loading={isSaving}>Save</Button>
          <Button negative onClick={this.props.onClose}>Cancel</Button>
        </Modal.Actions>
      </Modal>
    )
  }

  handleChangeDescription = event => {
    this.props.model.setDescription(event.target.value)
  }

  handleChangeCost = event => {
    const parsedValue = parseFloat(event.target.value)
    if (!isNaN(parsedValue)) {
      this.props.model.setCost(parsedValue)
    }
  }

}
 
export default observer(OtherCostForm);


// WEBPACK FOOTER //
// ./src/components/jobs/OtherCostForm.js